// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_container__UNIu_","content":"footer_content__C_uiz","logo":"footer_logo__z_NFK","acum":"footer_acum__Tegg_"};